var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGfxArrowBecomes(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "176px",
    height: "71px",
    viewBox: "0 0 176 71",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "gfx_ArrowBecomes") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "gfx_ArrowBecomes",
    transform: "translate(0.000000, 0.170550)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M126.017487,51.1513177 L0,51.1513177 L0,19.1513177 L126.017487,19.1513177 L126.017487,0 L176.017487,35 L126.017487,70 L126.017487,51.1513177 Z",
    id: "Combined-Shape",
    fill: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("text", {
    id: "BECOMES",
    fontFamily: "SourceSansPro-Bold, Source Sans Pro",
    fontSize: 13,
    fontWeight: "bold",
    fill: "#1A4480"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 50.5937616,
    y: 39.5
  }, "BECOMES"))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGfxArrowBecomes);
export default __webpack_public_path__ + "static/media/gfx_ArrowBecomes.b3931791adec3ec3bb06b181de700820.svg";
export { ForwardRef as ReactComponent };